import { isoFromMillis } from "./dates.js";
/**
 * OLDEST first, and only the events that mean something to a person.
 *
 * Chronological rather than newest-first, because the timeline it draws does
 * not stop at the last event: it runs on to the expiry, with the line between
 * filled for the shelf life already spent. That is a story with a direction —
 * bought here, still good until there — and it only reads in one order.
 *
 * `edited` is excluded on purpose: it is bookkeeping, it would be by far the
 * most frequent line, and "you changed something" tells the user nothing they
 * did not already know from having changed it.
 */
export function describeHistory(events, timezone) {
    const out = [];
    for (const e of events) {
        const shown = describe(e);
        if (!shown)
            continue;
        out.push({
            id: e.id,
            at: e.at,
            on: isoFromMillis(e.at, timezone),
            text: shown.text,
            tone: shown.tone,
        });
    }
    return out.sort((a, b) => a.at - b.at);
}
function describe(e) {
    switch (e.type) {
        case "added":
            return { text: "Added", tone: "plain" };
        case "ate":
            return { text: "Eaten", tone: "good" };
        case "tossed":
            return { text: "Thrown away", tone: "bad" };
        case "presumed":
            return { text: "Presumed gone", tone: "bad" };
        case "still_here":
            // The bump is the whole content of the event — "still here" without it is
            // an answer with no consequence attached.
            return {
                text: e.bumpDays ? `Still here · +${e.bumpDays}d` : "Still here",
                tone: "good",
            };
        case "rated":
            return e.verdict ? { text: VERDICT[e.verdict], tone: "plain" } : null;
        default:
            return null;
    }
}
const VERDICT = {
    loved: "Loved it",
    fine: "It was fine",
    never_again: "Never again",
};
//# sourceMappingURL=history.js.map